<template>
  <div>
    <div>
      <div class="bg-white padding">
        <div style="position: relative; z-index: 2" ref="card" v-show="childBindingList.length>0 && isChildBindFeatureEnabled">
          <div class="input-item flex">
            <div style="display: flex">
              <div class="line"></div>
              <span class="text-nowrap">已綁定子女</span>
            </div>
            <div>
              <span style="font-size: 16px" class="text-blue" @click="changeModifyListStatus">{{ isListInModify ? '完成' : '編輯' }}</span>
            </div>
          </div>
          <div class="dark-card">
            <div v-for="(item, i) in childBindingList" :key="i" class="flex border">
              <div>
                <div style="font-size: 16pt" class="text-gray1">{{ item.student_name | hideName }}</div>
                <div style="font-size: 14px" class="text-gray2">{{ item.student_id_number | hideId }}</div>
              </div>
              <div class="delete-fill" v-if="isListInModify" @click="removeChildBound(item.parent_child_bind_serial_number)"></div>
            </div>
          </div>

          <button
            class="text-nowrap"
            :class="isListInModify ? 'btn btn-white' : 'btn btn-primary'"
            style="margin-top: 16px;"
            :hidden="isListInModify"
            @click="getPaymentInformation(false)"
          >
            查詢帳單
          </button>
        </div>
        <div style="padding: 10pt 0 32pt 0" v-if="(childBindingList.length==0 || isListInModify) && isChildBindFeatureEnabled">
          <div class="input-item flex" style="padding-bottom: 16pt">
            <div style="display: flex; align-items: center">
              <div class="line"></div>
              {{isListInModify ? "新增綁定子女" : "綁定子女資料"}}
            </div>
          </div>
          <div style="padding-bottom: 16pt;">
            <input
                type="text"
                name="student_id_number"
                placeholder="請輸入子女身分證字號"
                class="input vinput"
                v-model.trim="studentIdNumber"
                @keyup="changeIDNumber"
                :class="studentIdError===null ? '' : 'error'"
              />
              <div class="required required-no-margin" v-if="studentIdError!==null">{{ studentIdError }}</div>

          </div>
          <button class="btn btn-primary" @click="addChildBinding" :disabled="!isStudentIdNumberValid">下一步</button>
        </div>
        <div class="input-item flex" style="justify-content: space-between; margin-top: 16px">
          <div style="display: flex; align-items: center">
            <div class="line"></div>
            <span class="text-nowrap">請輸入條碼</span>
          </div>
          <div class="icon-scan" @click="openScanner">掃描</div>
        </div>
        <div class="form">
          <div>
            <div class="field">
              <span class="required">*</span>
              第一段條碼
            </div>
            <input
              type="text"
              name="id_card_number"
              :placeholder="`${verify.barcode1.placeholder}`"
              class="input vinput"
              :maxlength="verify.barcode1.maxLength"
              v-model.trim="form.barcode1"
              @blur="verifyForm('barcode1')"
              @input="verifyInput('barcode1')"
              :class="verify.barcode1.status ? '' : 'error'"
            />
            <div class="required">{{ verify.barcode1.text }}</div>
          </div>
          <div>
            <div class="field">
              <span class="required">*</span>
              第二段條碼
            </div>
            <input
              type="text"
              name="id_card_number"
              :placeholder="`${verify.barcode2.placeholder}`"
              class="input vinput"
              :minlength="verify.barcode2.minLength"
              :maxlength="verify.barcode2.maxLength"
              v-model="form.barcode2"
              @blur="verifyForm('barcode2')"
              @input="verifyInput('barcode2')"
              :class="verify.barcode2.status ? '' : 'error'"
            />
            <div class="required">{{ verify.barcode2.text }}</div>
          </div>
          <div>
            <div class="field">
              <span class="required">*</span>
              第三段條碼
            </div>
            <input
              type="text"
              name="id_card_number"
              :placeholder="`${verify.barcode3.placeholder}`"
              class="input vinput"
              :minlength="verify.barcode3.minLength"
              :maxlength="verify.barcode3.maxLength"
              v-model.trim="form.barcode3"
              @blur="verifyForm('barcode3')"
              @input="verifyInput('barcode3')"
              :class="verify.barcode3.status ? '' : 'error'"
            />
            <div class="required">{{ verify.barcode3.text }}</div>
          </div>
        </div>
        <button class="btn btn-primary" :disabled="search_btn_disable" ref="search_btn" @click="getPaymentInformation(true)">查詢帳單</button>
        <div class="hint" @click="showSupportSchools()"><span>不確定哪些學校可以繳？</span><img src="../../assets/images/infoButton.png" style="width: 24px; height: 24px;"></div>
      </div>
      <div class="padding description">
        <ul class="text-gray2">
          <li>請尋找您手上費用帳單的超商專用「三段式條碼」進行掃描。</li>
          <li>學雜費代收服務，由台灣票據交換所及合作銀行(台北富邦銀行 &臺灣銀行 )提供。</li>
          <li>可使用悠遊付錢包、銀行帳戶連結、信用卡(<span class="text-blue">限台新銀行、玉山銀行發卡</span>)進行繳費扣款。</li>
          <li>若需繳費證明，請至【臺灣銀行-學雜費入口網】 或 【學校之校務系統】列印繳費收據。</li>
          <li>如須辦理退費，請向各級學校申請人工退費。</li>
        </ul>
      </div>
    </div>
    <div v-if="dialog">
      <div class="dialog">
        <div class="img-box"><img src="../../assets/images/familyId@3x.png" /></div>
        <div class="dialog-text">
          是否要把<span class="text-blue">子女身分證字號</span>及<span class="text-blue">您的手機號碼</span>
          傳送至{{ cityDescription }}教育局查詢親子關係？
        </div>
        <div class="agree-label" style="margin-bottom: 16pt">
          <input type="checkbox" id="isAddFavoriteChecked" v-model="isAgreementChecked" @click.stop="clickAgreeBtn" />
          <label for="isAddFavoriteChecked">
            我已經詳閱並同意
            <router-link :to="'/tuition/newTaipeiCityTermsOfPolicy'" class="text-blue">悠遊付會員為申請親子綁定及學校費用繳納個資提供同意條款</router-link>
          </label>
        </div>
        <button class="btn btn-primary" @click="goAddList" :disabled="!isAgreementChecked">確定</button>
        <button class="btn btn-white" style="border: 0" @click="dialog = !dialog">取消</button>
      </div>
      <div class="dialog-mask"></div>
    </div>
    <transition>
      <section v-show="supportSchoolModal.show">
        <div class="bottom-dialog" :class="supportSchoolModal.show ? 'up' : 'down'">
          <div class="title-wrap">
            <div class="title">{{ cityDescription }}學校清單</div>
            <div class="icon-cancel" @click="closeSupportSchools"></div>
          </div>
          <div class="search-bar">
              <img src="../../assets/images/tuitionFee/barsSearchBarResourcesSearchGlyph.png" style="width: 14px; height: 14px; margin-right: 8px;">
              <input placeholder="請輸入校名" v-model="supportSchoolModal.filterKeyword" @input="filter()" />
              <img src="../../assets/images/tuitionFee/clear.png" style="width: 14px; height: 14px; " v-show="supportSchoolModal.filterKeyword !== ''" @click="clearFilter()">
          </div>
          
          <div ref="bottomDialogContent" class="bottom-dialog-content" :class="supportSchoolModal.show ? 'dialog-navbar' : ''">
            <div v-if="supportSchoolModal.filteredSupportSchools.length===0" class="empty">查無資料</div>
            <div @click="schoolClicked(school)" v-for="(school, i) in supportSchoolModal.filteredSupportSchools" :key="i">
              <div class="block">
                <div class="item-title" v-if="school.is_city">
                  <div class="text-gray2">{{ school.city_name }}</div>
                </div>
                <div class="item" v-if="!school.is_city">
                  <div class="text-gray2">{{ school.school_name }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="mask"></div>
      </section>
    </transition>
  </div>
</template>
<script>
import { queryBillList, queryCitySupportShoolList, queryCityChildRelation, queryCityChildBinding, deleteCityChildBinding, saveCityChildBinding } from '../../api/api';
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'new-taipei-city-school-fee',
  components: {
  },
  data() {
    return {
      cityName: 'newTaipeiCity',
      cityDescription: '新北市',
      isAgreementChecked: false,
      studentIdError: null,
      openScan: true,
      dialog: false,
      studentIdNumber: '',
      form: {
        barcode1: '',
        barcode2: '',
        barcode3: '',
      },
      verify: {
        barcode1: {
          status: true,
          text: '',
          placeholder: '共 9 碼',
          verifyRegex: '^([0-9]{6}[0-9a-zA-Z]{3})$',
          verifyErrorText: '前6碼需為數字，後3碼限數字及英文'
        },
        barcode2: {
          status: true,
          text: '',
          placeholder: '共 14 ~ 20 碼',
          verifyRegex: '^([0-9a-zA-Z]{16,20}|[0-9a-zA-Z]{14})$',
          verifyErrorText: '需為 14 ~ 20 碼'
        },
        barcode3: {
          status: true,
          text: '',
          placeholder: '共 10 或 15 碼',
          verifyRegex: '^([a-zA-Z0-9]{10}|[0-9a-zA-Z]{15})$',
          verifyErrorText: '需為 10 ~ 15 碼'
        },
      },
      verifyInputRule: {
        barcode1: false,
        barcode2: false,
        barcode3: false,
      },
      childBindingList: [],
      isListInModify: false,
      supportSchoolModal: {
        filterKeyword: '',
        show: false,
        supportSchools: [],
        filteredSupportSchools: [],
      }
    };
  },
  created() {
    if (this.isChildBindFeatureEnabled) {
      this.queryChildBound();
    }
    window.getScanningResult = this.getScanningResult;
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      if (from.path === '/tuition/newTaipeiCityTermsOfPolicy') {
        vm.dialog = true;
        vm.isAgreementChecked = vm.isTuitionFeeAgreementChecked;
        vm.studentIdNumber = vm.pendingStudentIdNumber;
      }
    });
  },
  filters: {
    hideName(value) {
      let first = value.substr(0, 1);
      let last = value.substr(-1, 1);
      let hide = '';
      for (let i = 0; i < value.length - 2; i++) {
        hide += 'O';
      }
      return `${first}${hide}${last}`;
    },
    hideId(value) {
      let first = value.substr(0, 3);
      let last = value.substr(6, 4);
      let hide = '';
      for (let i = 0; i < value.length - 7; i++) {
        hide += '*';
      }
      return `${first}${hide}${last}`;
    },
  },
  computed: {
    ...mapGetters(['isTuitionFeeAgreementChecked', 'pendingStudentIdNumber']),
    search_btn_disable() {
      return !Object.values(this.verifyInputRule).every((i) => i === true);
    },
    isStudentIdNumberValid() {
      return this.studentIdNumber.match(/^[A-Z]{1}[1-2]{1}[0-9]{8}$/) !== null;
    },
    agreeTermsChecked() {
      return !this.isAgreementChecked;
    },
    isChildBindFeatureEnabled() {
      return new Date('2024-08-01T10:00:00.000+08:00') < new Date();
    }
  },
  methods: {    
    ...mapActions(['setStudentInformation', 'setReadyToPayBill', 'setPendingStudentIdNumber']),
    clearFilter() {
      this.supportSchoolModal.filterKeyword = '';
      this.filter();
    },
    goAddList() {
      if (this.isAgreementChecked) {
        this.dialog = false;
        queryCityChildRelation(this.cityName, this.studentIdNumber).then((res) => {
          if (res === undefined) {
            this.isAgreementChecked = false;
            return;
          }
          if (res.error !== undefined) {
            alert(res.error.message);
            this.isAgreementChecked = false;
            return;
          }
          this.setStudentInformation(res);
          this.$router.push({ path: '/tuitionFee/newTaipeiCityChildBindingAddList', query: {city_name: this.cityName}});
        });
      }
    },
    queryChildBound() {
      queryCityChildBinding(this.cityName).then((res) => {    
        if (res === undefined) {
          return;
        }
        if (res.error === undefined) {
          this.childBindingList = res.parent_child_bind_list;
          // setTimeout(() => {
          //   var height = this.$refs.card.clientHeight;
          //   this.$refs.mask.style.top = height + 'px';
          // }, 1000);
        }
      });
    },
    changeModifyListStatus() {
      this.isListInModify = !this.isListInModify;
    },
    addChildBinding() {
      this.dialog = true;
      this.setPendingStudentIdNumber(this.studentIdNumber);
    },
    removeChildBound(id) {
      if (confirm('確定要刪除？')) {
        deleteCityChildBinding(this.cityName, id).then((res) => {
          if (!res.error) {
            this.isListInModify = false;
            this.queryChildBound();
          } else {
            alert(res.error.message);
          }
        });
      }
    },
    clickAgreeBtn() {
      this.isAgreementChecked = !this.isAgreementChecked;
    },
    changeIDNumber(e) {
      e.target.value = e.target.value.replace(/[\W]/g, '');
      if (e.target.value.match(/^[A-Z]{1}[1-2]{1}[0-9]{8}$/) === null) {
        //e.target.blur();
        this.studentIdError = '身分證格式錯誤';
      } else {
        this.studentIdError = null;
      }
    },
    filter() {
      if (this.supportSchoolModal.filterKeyword === '') {
        this.generateFilterSchools(this.supportSchoolModal.supportSchools);
      } else {
        var list = [];
        this.supportSchoolModal.supportSchools.forEach((item, i) => {
          if (item.school_name.indexOf(this.supportSchoolModal.filterKeyword) !== -1) {
            item.is_city = false;
            list.push(item);
          }
        });
        this.generateFilterSchools(list);
      }
    },
    generateFilterSchools(list) {
      this.supportSchoolModal.filteredSupportSchools = [];
      var lastCity = null;
      list.forEach((item, i) => {
        if (item.city_name !== lastCity) {
            let city = Object.create(item);
            city.is_city = true;
            this.supportSchoolModal.filteredSupportSchools.push(city);  
        } 
        item.is_city = false;
        this.supportSchoolModal.filteredSupportSchools.push(item);
        lastCity = item.city_name;
      });
    },
    schoolClicked(school) {
      //alert(school.school_name);
    },
    closeSupportSchools() {
      this.supportSchoolModal.show = false;
    },
    showSupportSchools() {
      queryCitySupportShoolList(this.cityName).then((res) => {
        if (res === undefined) {
          return;
        }
        if (res.error === undefined) {
          this.supportSchoolModal.supportSchools = res.school_list;
          this.filter();
          this.supportSchoolModal.show = true;
        }
      });
    },
    verifyForm(fieldName) {
      if (!this.verifyInput(fieldName)) {
        this.verify[fieldName].status = false;
        this.verify[fieldName].text = this.verify[fieldName].verifyErrorText;
        return false;
      } else {
        this.verify[fieldName].status = true;
        this.verify[fieldName].text = '';
        return true;
      }
    },
    verifyInput(fieldName) {
      const regexp = RegExp(/[\d|a-zA-Z|\\+|\\=|\\.|\-|\\$|\\|\s]+$/);
      let result = regexp.test(this.form[fieldName]);
      this.form[fieldName] = this.form[fieldName].toUpperCase();

      if (result) {
        if (new RegExp(this.verify[fieldName].verifyRegex).test(this.form[fieldName])) {
          this.verifyInputRule[fieldName] = true;
        } else {
          this.verifyInputRule[fieldName] = false;
        }
      } else {
        this.verifyInputRule[fieldName] = false;
      }
      return this.verifyInputRule[fieldName];
    },
    getScannerBarcodeRegex() {
      let regexList = []
      for (let k in this.verify) {
        regexList.push(this.verify[k].verifyRegex);
      }
      return regexList;
    },
    openScanner() {
      let form = Object.assign({}, this.form);
      for (let k in this.verify) {
        if (this.verify[k].status === false) {
          form[k] = '';
        }
      }

      this.$store.dispatch('sentApp', {
        action: 'openScanner',
        payload: { type: 3, content: form, isAllowInput: true, barcodeRegex: this.getScannerBarcodeRegex() },
      });
    },
    getFormData(taxData) {  
      let d = JSON.parse(taxData);
      for (let i = 0; i <= 2; i++) {
        this.form['barcode' + (i + 1)] = d[i];
        if (d[i]) {
          this.verifyForm(`barcode${i + 1}`);
        }
      }
    },
    validateForm() {
      var allSuccess = true;
      for (let i = 0; i <= 2; i++) {
        allSuccess = allSuccess && this.verifyForm(`barcode${i + 1}`);
      }
      return allSuccess;
    },
    getScanningResult(taxBarcode) {
      this.getFormData(taxBarcode);
      this.openScan = false;
    },
    getPaymentInformation(isScanning) {
      if (isScanning && !this.validateForm()) {
        return;
      }
      var form = isScanning ? {
        payment_item_id: 'TWNCH-0707',
        payment_query_type: 3,
        parameter1: this.form.barcode1,
        parameter2: this.form.barcode2,
        parameter3: this.form.barcode3,
        payment_custom_id: '',
      } : {
        payment_item_id: 'TWNCH-0707',
        payment_query_type: 'REALTIME-1',
        parameter1: this.cityName,
        parameter2: '',
        parameter3: '',
        payment_custom_id: '',
      };
      queryBillList(form).then((res) => {
        if (res.error === undefined) {
          this.setReadyToPayBill(res);
          if (isScanning) {
            this.$router.push({
              path: '/goPay',
              query: form,
            });
          } else {
            this.$router.push({
              path: '/goPay',
              query: form,
            });
          }
        } else {
          alert(res.error.message);
        }
      });
    },
  },
};
</script>
<style type="text/scss" lang="scss" scoped>
.flex {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.dark-card {
  background-color: #f5f5f5;
  padding: 15px 13px;
  box-shadow: 0 0 0 0px rgba(0, 0, 0, 0.1);
}

.required {
  margin-top: 2pt;
  margin-bottom: 26pt;
  font-size: 12pt;
}

.required-no-margin {
  margin-top: 2pt;
  font-size: 12pt;
  margin-bottom: 0pt;
}

.hint {
  display: flex;
  flex-flow: row;
  align-items: center;
  margin: 18px auto 0px auto;
  justify-content: center;
}

.hint span {
  color: rgba(64, 64, 64, 0.6);
  font-size: 14px;
  text-align: center;  
  line-height: 24px;
}


.up {
  animation: slideUp 0.3s ease-in-out both;
}

.down {
  animation: slideDown 0.3s ease-in-out both;
}

.item {
  min-height: 56px;
  padding-left: 20px;
  padding-right: 20px;
  background: white;
  
}

.item-title {
  margin: 8px 20px;  
  font-size: 14px;
}

.item .text-gray2 {
  border-bottom-color: rgba(64, 64, 64, 0.1);
  border-bottom-width: 1px;
  border-bottom-style: solid;
  line-height: 55px;
}

.search-bar {
  display: flex;
  flex-direction: row;
  vertical-align: middle;
  position: relative;
  top: 30px;
  height:36px;
  margin: 0px 20px 15px 20px;
  background: rgba(142, 142, 147, 0.12);
  padding: 6px 12px;
  align-items: center;
  justify-content: center;
}
 
.empty {
  color: rgba(64, 64, 64, 0.4);
  font-size: 16px;
  margin: 24px auto;
  text-align: center;
}
 
.search-bar input {
  background: transparent;
  border-style: none;
  height: 36px;
  flex-grow: 1;
}

.bottom-dialog .bottom-dialog-content {
}

@keyframes slideUp {
  0% {
    transform: translateY(100%);
  }
  100% {
    transform: translateY(0);
  }
}

@keyframes slideDown {
  0% {
    transform: translateY(0);
  }
  100% {
    transform: translateY(100%);
  }
}


.dialog {
  z-index: 99;
  background-color: #fff;
  padding: 24pt 20pt;
  border-radius: 16pt;
  position: fixed;
  top: 50%;
  transform: translate(0, -50%);
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 0 10%;

  .img-box {
    width: 100%;
    padding: 0 20pt 16pt 20pt;

    img {
      width: 100%;
    }
  }

  .dialog-text {
    text-align: center;
    font-size: 18px;
  }

  .agree-label {
    font-size: 14px;
    margin: 34pt 0 18pt 0;
    position: relative;

    label {
      text-align: left;
      display: inline-block;
      margin-left: 40px;
      vertical-align: center;
      align-items: center;
    }

    a:active {
      -webkit-tap-highlight-color: transparent;
    }
  }

  .agree-label label::before {
    position: absolute;
    top: 50%;
    left: 0;
    transform: translateY(-50%);
  }
}
</style>
